import React from 'react';
// @ts-ignore
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import GoogleLogin from 'react-google-login';
import LOGIN from './social-login-mutation';
import { Mutation, MutationFunction } from 'react-apollo';
import { navigate } from '@reach/router';
import classes from './social-login.module.scss';
import { SnackBarContext } from '../../../../App';

interface IFacebookInfo {
  id: string;
  email?: string;
  first_name: string;
  last_name: string;
  picture: {
    data: {
      url: string;
    };
  };
}

const SocialLogin = ({ redirectTo }) => {
  const responseFacebook = (
    response: IFacebookInfo,
    mutationFn: MutationFunction
  ) => {
    if (!response.email) {
      console.log(`Email обов'язковий`); // tslint:disable-line
    }
    mutationFn({
      variables: {
        email: response.email,
        firstName: response.first_name,
        id: response.id,
        lastName: response.last_name,
        imageUrl: response.picture && response.picture.data.url,
        provider: 'facebook'
      }
    });
  };

  const responseGoogle = (response: any, mutationFn: MutationFunction) => {
    mutationFn({
      variables: {
        email: response.profileObj.email,
        firstName: response.profileObj.givenName,
        id: response.profileObj.googleId,
        lastName: response.profileObj.familyName,
        imageUrl: response.profileObj.imageUrl,
        provider: 'google'
      }
    });
  };

  return (
    <div className={classes.socialMediaLogin}>
      <span style={{ marginBottom: '20px' }}>Увійти через</span>

      <SnackBarContext.Consumer>
        {({ openSnackBar }) => (
          <div className={classes.buttonsContainer}>
            <Mutation
              mutation={LOGIN}
              onError={error => {
                openSnackBar('error', error.graphQLErrors[0].message);
              }}
              onCompleted={data => {
                const { token } = data.loginOrRegister;
                if (token) {
                  localStorage.setItem('token', token);
                  navigate(redirectTo);
                }
              }}
            >
              {(mutationFn, { loading, error }) => {
                if (loading) {
                  console.log('Loading ...'); // tslint:disable-line
                }
                if (error) {
                  console.log('Google error'); // tslint:disable-line
                }

                return (
                  <GoogleLogin
                    clientId="972051869631-bm2d5j76473p9liotd9cem787cigmijr.apps.googleusercontent.com"
                    render={(renderProps: any) => (
                      <button
                        className={classes['login-provider-button']}
                        onClick={renderProps.onClick}
                      >
                        <img
                          src="/assets/google.png"
                          alt="login using google"
                        />
                        <span>Google</span>
                      </button>
                    )} // tslint:disable-line
                    onSuccess={res => responseGoogle(res, mutationFn)} // tslint:disable-line
                    onFailure={() => console.log('Something went wrong')} // tslint:disable-line
                  />
                );
              }}
            </Mutation>

            <Mutation
              mutation={LOGIN}
              onError={error =>
                openSnackBar('error', error.graphQLErrors[0].message)
              }
              onCompleted={data => {
                const { token } = data.loginOrRegister;
                if (token) {
                  localStorage.setItem('token', token);
                  navigate(redirectTo);
                }
              }}
            >
              {(loginOrRegister, { loading, error }) => {
                if (loading) {
                  console.log('Loading ...'); // tslint:disable-line
                }
                if (error) {
                  console.log('Facebook error'); // tslint:disable-line
                }

                return (
                  <FacebookLogin
                    appId="2282928271962756"
                    fields="first_name,last_name,email,picture"
                    callback={
                      (res: IFacebookInfo) =>
                        responseFacebook(res, loginOrRegister) // tslint:disable-line
                    }
                    render={(renderProps: any) => (
                      <button
                        className={classes['login-provider-button']}
                        onClick={renderProps.onClick}
                      >
                        <img
                          style={{ borderRadius: '4px' }}
                          src="/assets/fb.png"
                          alt="login using facebook"
                        />
                        <span>Facebook</span>
                      </button>
                    )} // tslint:disable-line
                  />
                );
              }}
            </Mutation>
          </div>
        )}
      </SnackBarContext.Consumer>
    </div>
  );
};

export default SocialLogin;
